export const UserRegistrationStatus = {
    DRAFT: 'DRAFT', //Starting Status
    CONTACT_CREATED: 'CONTACT_CREATED', //Contact has been created and persisted in the database
    MAC_SYNC_COMPLETE: 'MAC_SYNC_COMPLETE', //Mac has received the information and generated a MAC ID
    MAC_SYNC_ERROR: 'MAC_SYNC_ERROR', // Mac failed to sync the information and could not generate a MAC ID
    CONTRACT_CREATION_ERROR: 'CONTRACT_CREATION_ERROR', //Contract could not be created in MAC, have the user communicate with customer service
    ACTIVATION_ERROR: 'ACTIVATION_ERROR', //Account could not be activated, but billing will have taken place, have the user communicate with customer service
    COMPLETED: 'COMPLETED' //Everything went well.
}

export const doesRedirectToConfirmationPage = (status) => {
    return status === UserRegistrationStatus.CONTRACT_CREATION_ERROR 
        || status === UserRegistrationStatus.ACTIVATION_ERROR 
        || status === UserRegistrationStatus.COMPLETED;
}